package com.arena_web.ui.components

import androidx.compose.runtime.Composable
import com.arena_web.ui.utils.Constants
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreBadges() {
    Row(modifier = Modifier.styleModifier {
        property("gap", "12px")
        property("flex-wrap", "wrap")
    }) {
        StoreBadge("Download on the", "App Store", Constants.APP_STORE_URL)
        StoreBadge("Get it on", "Google Play", Constants.GOOGLE_PLAY_URL)
    }
}

@Composable
private fun StoreBadge(eyebrow: String, name: String, href: String) {
    A(
        href = href,
        attrs = {
            target(ATarget.Blank)
            attr("rel", "noopener noreferrer")
            style {
                property("display", "inline-flex")
                property("flex-direction", "column")
                property("padding", "8px 18px")
                property("border-radius", "12px")
                property("background", "#0061FF")
                property("color", "#FFFFFF")
                property("text-decoration", "none")
                property("font-family", "Urbanist, sans-serif")
                property("line-height", "1.15")
            }
        }
    ) {
        org.jetbrains.compose.web.dom.Span(attrs = { style { property("font-size", "10px"); property("opacity", "0.85") } }) { Text(eyebrow) }
        org.jetbrains.compose.web.dom.Span(attrs = { style { property("font-size", "17px"); property("font-weight", "700") } }) { Text(name) }
    }
}
